import { render } from "./TheA01Carousel.vue?vue&type=template&id=4a723c94&scoped=true&ts=true"
import script from "./TheA01Carousel.vue?vue&type=script&lang=ts"
export * from "./TheA01Carousel.vue?vue&type=script&lang=ts"

import "./TheA01Carousel.vue?vue&type=style&index=0&id=4a723c94&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a723c94"]])

export default __exports__